import { useReturnTo } from "@/features/material-compliance/hooks/useReturnTo"
import { useTranslation } from "@/hooks/useTranslation/useTranslation"
import { ArrowLeft } from "lucide-react"
import { Link } from "react-router"

/**
 * Shown above the master-data pages only when arriving via a statement's gap
 * hint (`?return_to=<url>`, TUR-1539 D5). Lets the reviewer jump back to the
 * declaration after fixing the data gap it flagged.
 */
export function ReturnToStatementBanner() {
  const { translate } = useTranslation()
  const returnTo = useReturnTo()
  if (!returnTo) return null

  return (
    <Link
      to={returnTo}
      className="mb-3 flex w-fit items-center gap-2 rounded-md border border-grey4 bg-grey2 px-3 py-1.5 text-sm text-white hover:border-grey5"
    >
      <ArrowLeft size={14} />
      {translate("MC_MD_GAPS_RETURN_TO_STATEMENT")}
    </Link>
  )
}
